// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3syxx","inner":"Footer_inner__1y9vk"};